import { PDFViewerProps } from "@react-pdf/renderer";
import dynamic from "next/dynamic";

export const PDFViewer = dynamic<PDFViewerProps>(
	() => import("@react-pdf/renderer").then((module) => module.PDFViewer),
	{ ssr: false },
);
